import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("ptg_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ptg_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ptg_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const studentLogin = async (rollNumber, password) => {
    const { data } = await api.post("/auth/student/login", { roll_number: rollNumber, password });
    localStorage.setItem("ptg_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const studentRegister = async (payload) => {
    const { data } = await api.post("/auth/student/register", payload);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("ptg_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, studentLogin, studentRegister, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
